module.exports = __webpack_public_path__ + "img/camera_no_black.15197219.png";